import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet} from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { Subject, takeUntil } from 'rxjs';
import { LoaderService } from '@coreServices';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, NgxLoadingModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {

  isLoading: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    public loaderService: LoaderService,
  ) {
  }

  ngOnInit() {
    this.loaderService.loading$.pipe(takeUntil(this.destroy$)).subscribe((isLoading) => {
      setTimeout(() => {
        this.isLoading = isLoading;
      }, 0);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
